import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import { MuiGridTextView } from '../MuiGridTextView';

export const renderMuiGridTextView = ({ value }: GridRenderCellParams, customValue?: React.ReactNode) => (
    <MuiGridTextView>{customValue ?? value}</MuiGridTextView>
);
